
'use strict';


import {Component,Input, Output, EventEmitter, Inject} from 'ng-metadata/core';
import {LimitedHistoryStack} from '../../../../infra/dataStructures/collections/stack/limitedHistoryStack.structure';

//your imports go here

import {OPAC_TAB} from './opac.directive';
import {ChangeTabEvent} from './opac.directive';

@Component({
	'selector': 'prm-opac-back-button',
	templateUrl: 'components/search/fullView/getit/opac/back-button.html',
})


export class PrmOpacBackButton {
	@Input() 	private historyStack: LimitedHistoryStack<OPAC_TAB>;
	@Input() 	private requestStatus: boolean;
	@Output() 	private changeTabEvent: EventEmitter<ChangeTabEvent>= new EventEmitter();

			constructor(@Inject('opacLocations') private opacLocations){}

	get label():string{
		let destTab = this.historyStack.peek();
		switch(destTab){
			case OPAC_TAB.LIBRARIES: return 'nui.libraries.back';
			case OPAC_TAB.LOCATIONS: return 'nui.locations.back';
			case OPAC_TAB.ITEMS: return 'nui.items.back';
			default: return 'eshelf.back'; //Generic 'Back' label
		}
	}


	public goBack():void{
		let destTab = this.historyStack.pop();
		if (this.requestStatus){
			destTab = this.historyStack.pop();
			this.changeTabEvent.emit({
				dest: destTab,
				referer: this.historyStack.peek(),
				updateLocationItems: destTab === OPAC_TAB.ITEMS
			});
		}
		else{
			this.changeTabEvent.emit({
				dest: destTab
			});
		}
	}

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/backButton.directive.ts